<div class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1
            *ngIf="this.id === 'new'"
            class="card__title--h1 color--white layout-page-title"
        >
            New report: {{ object.Name }}
        </h1>
        <h1
            *ngIf="this.id !== 'new'"
            class="card__title--h1 color--white layout-page-title p-pb-2"
            style="margin: 0rem 0.5rem"
        >
            {{ reportTypeName }}: {{ object.Name }}
        </h1>
        <button
            *ngIf="this.id !== 'new'"
            style="font-size: 16px; vertical-align: super"
            pButton
            (click)="editReport()"
            pTooltip="Edit Details"
            tooltipPosition="top"
            icon="pi pi-pencil"
        ></button>
        <button
            *ngIf="this.id !== 'new'"
            style="font-size: 16px; vertical-align: super"
            pButton
            (click)="openPictureChange()"
            pTooltip="Change Picture"
            tooltipPosition="top"
            icon="pi pi-image"
        ></button>
        <button
            *ngIf="this.id !== 'new' && this.object.ReportPreviewLink"
            style="font-size: 16px; vertical-align: super"
            pButton
            (click)="previewReport()"
            pTooltip="Preview"
            tooltipPosition="top"
            icon="pi pi-external-link"
        ></button>
        <p-dialog
            *ngIf="this.id !== 'new' && displayPictureChange"
            header="Change Report Picture"
            [modal]="true"
            [(visible)]="displayPictureChange"
            [style]="{ width: 'auto' }"
            appendTo="body"
            [draggable]="false"
        >
            <div class="ui-g">
                <div
                    id="uploadedPhotoWrapper"
                    class="ui-g-12"
                    style="padding: 0px"
                >
                    <img
                        id="photoToUpload"
                        src="/assets/layout/images/loader.gif"
                        height="100"
                        width="auto"
                    />
                </div>
                <div class="ui-g-12" style="padding-top: 0px">
                    <p-fileUpload
                        id="photo"
                        name="photo"
                        [url]="this.urlPicturePost"
                        (onUpload)="onUpload($event)"
                        [showUploadButton]="
                            this.id !== 'new' && this.allowUpload === true
                        "
                        [showCancelButton]="false"
                        (onSelect)="onPictureSelect($event)"
                        accept=".jpg,.jpeg,.png"
                    >
                    </p-fileUpload>
                </div>
            </div>
        </p-dialog>
        <br />
        <p
            *ngIf="this.id !== 'new'"
            class="color--white layout-page-title block"
            style="margin: 0rem 0.5rem"
        >
            {{ object.Description }}
        </p>
    </div>
    <div class="ui-g-12">
        <div class="card">
            <div class="ui-g form-group" *ngIf="this.id === 'new'">
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <p-dropdown
                            [disabled]="!canReportTypeBeChanged"
                            [options]="reportTypes"
                            [(ngModel)]="object.ReportType"
                            dataKey="id"
                            optionLabel="name"
                            [autoDisplayFirst]="false"
                            (onChange)="onTypeReportChange($event)"
                        >
                        </p-dropdown>
                        <label>Report Type</label>
                    </div>
                </div>
                <div class="ui-g-12" *ngIf="this.displayReportAnalysisArea">
                    <div class="p-float-label">
                        <p-dropdown
                            [disabled]="!canReportTypeBeChanged"
                            [options]="factTypes"
                            [(ngModel)]="object.FactType"
                            dataKey="id"
                            optionLabel="name"
                            [autoDisplayFirst]="false"
                        >
                        </p-dropdown>
                        <label>Report Analysis Area</label>
                    </div>
                </div>
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <input
                            pInputText
                            [(ngModel)]="object.Name"
                            mask="AAAAAA"
                            [patterns]="nameMaskPattern"
                            [validation]="false"
                            class="p-p-2 ui-inputtext ui-corner-all ui-state-default ui-widget"
                            [maxLength]="20"
                        />
                        <label>Code</label>
                    </div>
                </div>
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <input
                            pInputText
                            [(ngModel)]="object.Description"
                            [maxLength]="80"
                            class="p-p-2 ui-inputtext ui-corner-all ui-state-default ui-widget"
                        />
                        <label>Name</label>
                    </div>
                </div>
            </div>

            <div class="ui-g">
                <div class="ui-g-12 ui-md-6 ui-lg-3">
                    <app-dimension-picker
                        label="Dimension 1"
                        header="Pick Dimension 1"
                        [(dimension)]="this.object.Dimension1"
                        [(dimensionId)]="this.object.DimensionId1"
                        [companyId]="this.companyId"
                    ></app-dimension-picker>
                </div>
                <div class="ui-g-12 ui-md-6 ui-lg-3">
                    <app-dimension-picker
                        label="Dimension 2"
                        header="Pick Dimension 2"
                        [(dimension)]="this.object.Dimension2"
                        [(dimensionId)]="this.object.DimensionId2"
                        [companyId]="this.companyId"
                    ></app-dimension-picker>
                </div>
                <div class="ui-g-12 ui-md-6 ui-lg-3">
                    <app-dimension-picker
                        label="Dimension 3"
                        header="Pick Dimension 3"
                        [(dimension)]="this.object.Dimension3"
                        [(dimensionId)]="this.object.DimensionId3"
                        [companyId]="this.companyId"
                    ></app-dimension-picker>
                </div>
                <div class="ui-g-12 ui-md-6 ui-lg-3">
                    <app-dimension-picker
                        label="Dimension 4"
                        header="Pick Dimension 4"
                        [(dimension)]="this.object.Dimension4"
                        [(dimensionId)]="this.object.DimensionId4"
                        [companyId]="this.companyId"
                    ></app-dimension-picker>
                </div>
            </div>

            <modal-filter-picker
                *ngIf="this.id !== 'new'"
                [filterAccounts]="object.Filter"
                [reportId]="this.id"
                (change)="updateFilterAccounts($event)"
            ></modal-filter-picker>

            <div *ngIf="this.id !== 'new'">
                <div class="ui-g-12" style="text-align: left">
                    <button
                        type="button"
                        icon="ui-icon-add"
                        label="New Line"
                        pButton
                        (click)="addClick()"
                        style="margin-right: 10px"
                    ></button>
                    <modal-show-report-accounts
                        [reportId]="this.id"
                        buttonIcon="ui-icon-remove-red-eye"
                        buttonText="Show Included Accounts "
                        filter="included"
                    ></modal-show-report-accounts>
                    <modal-show-report-accounts
                        [reportId]="this.id"
                        buttonIcon="ui-icon-remove-circle"
                        buttonText="Show Excluded Accounts"
                        filter="excluded"
                    ></modal-show-report-accounts>
                    <modal-show-report-accounts
                        [reportId]="this.id"
                        buttonIcon="ui-icon-list"
                        buttonText="Show All Accounts"
                        filter="all"
                    ></modal-show-report-accounts>
                </div>

                <div
                    class="ui-g-12 report-lines-table"
                    style="margin-bottom: 10px"
                >
                  <!-- TODO ikonice staviti na tri točkice dodati postojeće akcije
   draganddrop zamjen parenta
   selektiranje linije na kojoj se nalaziš, kod update-a/dodavanja, pozicioniraj page koji je na toj liniji
   -->

   <div #reportLinesGridContainer class="grid-container grid-loading-wrapper">
                <ejs-treegrid
  #treeGridObj
  [dataSource]="treeGridData"
  [allowSorting]="true"
  [allowPaging]="true"
  [pageSettings]="{ pageSize: 200 }"
  [treeColumnIndex]="1"
  [allowResizing]="true"
  [allowRowDragAndDrop]="true"
  [allowSelection]="true"
  [height]="reportLinesGridHeight"
  childMapping="Childrens"
  [contextMenuItems]="contextMenuItems"
  (contextMenuClick)="onContextMenuClick($event)"
  [allowFiltering]="true"
  [filterSettings]="filterOptions"
  (rowDrop)="onRowDrop($event)"
  (recordDoubleClick)="onRowDoubleClick($event)"
    (rowSelected)="onRowSelected($event)"
    (dataBound)="dataBound()"
    
>
  <e-columns>
    <e-column field="Id" headerText="ID #" width="6%" isPrimaryKey="true" [visible]="false"></e-column>
    <e-column field="RowNo" headerText="Row #" width="8%" [filter]="filterContains" textAlign="Left"></e-column>
    <e-column field="LineNo" headerText="LineNo" width="5%" [filter]="filterContains" [visible]="false"></e-column>
    <e-column field="TotalingType.name" headerText="Type" width="9%" [filter]="filterContains"></e-column>
    <e-column field="Description" headerText="Description" width="34%" [filter]="filterContains"></e-column>
    <e-column field="ParentLine.Name" headerText="ParentLine" width="32%" [filter]="filterContains"></e-column>
    <e-column headerText="Actions" width="8%" textAlign="Center" [customAttributes]="actionColumnAttributes" [template]="treeActions"></e-column>
  </e-columns>
<ng-template #treeActions let-data>
  <div class="actions-cell">
    <div class="action-menu-wrapper" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="action-menu-toggle"
        title="Actions"
        (click)="toggleDropdown(data, $event)"
      >
        &#8942;
      </button>
      <ul class="action-menu" *ngIf="isActionMenuOpen(data)">
        <li (click)="onActionMenuClick('edit', data, $event)">
          <i class="pi pi-pencil"></i>
          <span>Edit</span>
        </li>
        <li (click)="onActionMenuClick('copy', data, $event)">
          <i class="pi pi-copy"></i>
          <span>Copy</span>
        </li>
        <li *ngIf="data.TotalingType?.id == 1" (click)="onActionMenuClick('included', data, $event)">
          <i class="pi pi-eye"></i>
          <span>Included Accounts</span>
        </li>
        <li *ngIf="data.TotalingType?.id === 1" (click)="onActionMenuClick('excluded', data, $event)">
          <i class="pi pi-minus-circle"></i>
          <span>Excluded Accounts</span>
        </li>
        <li class="action-menu-danger" (click)="onActionMenuClick('delete', data, $event)">
          <i class="pi pi-trash"></i>
          <span>Delete</span>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
  <!-- <ng-template #treeActions let-data>
<button ejs-dropdownbutton
  [id]="'dropdown_' + data.Id"
  [name]="data.Id"
  [items]="getMenuItems(data)"
  iconCss="e-icons e-more-horizontal-1"
  cssClass="e-caret-hide"
  (select)="onDropdownItemClick($event, data)">
</button>
     <button ejs-dropdownbutton [name]="data.Id" [id]="data.Id"
 [items]="getMenuItems(data)"
 iconCss='e-icons e-more-horizontal-1'
    cssClass='e-caret-hide'
  (select)="onDropdownItemClick($event,data)">
</button>
    
<ejs-dropdownbutton
  content="Clipboard"
  [items]="dropdownItems"
  iconCss="e-icons e-down"
  cssClass="e-primary"
  (select)="onDropdownItemClick($event)">
</ejs-dropdownbutton>
 <div class="dropdown-wrapper" (click)="$event.stopPropagation()">
    <button class="dropdown-toggle" (click)="toggleDropdown(data, $event)">⋮</button>

    <ul class="dropdown-menu" *ngIf="data._dropdownOpen">
      <li (click)="viewReportDefinitionLine(data)">Edit</li>
      <li (click)="copyReportLine(data)">Copy</li>
      <li *ngIf="data.TotalingType?.id === 1" (click)="openSelectedLineAccounts(data)">Included Accounts</li>
      <li *ngIf="data.TotalingType?.id === 1" (click)="openExcludedLineAccounts(data)">Excluded Accounts</li>
      <li (click)="deleteReportDefinitionLine(data)">Delete</li>
    </ul>
  </div>
</ng-template>-->

   <!-- <button
      class="e-control e-btn"
      (click)="viewReportDefinitionLine(data); $event.stopPropagation()"
      title="Edit"
    >
      <i class="e-icons e-edit"></i>
    </button>
    <button
      class="e-control e-btn"
      (click)="copyReportLine(data); $event.stopPropagation()"
      title="Copy"
    >
      <i class="e-icons e-copy"></i>
    </button>
    <button
      *ngIf="data.TotalingType?.id === 1"
      class="e-control e-btn"
      (click)="openSelectedLineAccounts(data); $event.stopPropagation()"
      title="Included Accounts"
    >
      <i class="e-icons e-view"></i>
    </button>
    <button
      *ngIf="data.TotalingType?.id === 1"
      class="e-control e-btn"
      (click)="openExcludedLineAccounts(data); $event.stopPropagation()"
      title="Excluded Accounts"
    >
      <i class="e-icons e-cancel"></i>
    </button>
    <button
      class="e-control e-btn"
      (click)="deleteReportDefinitionLine(data); $event.stopPropagation()"
      title="Delete"
    >
      <i class="e-icons e-delete"></i>
    </button>
-->

  
</ejs-treegrid>
    <div *ngIf="loadingLines" class="grid-loading-overlay">
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>
<!--                    <p-table
                        [autoLayout]="true"
                        [value]="object.lines"
                        selectionMode="single"
                        dataKey="Id"
                        [loading]="loadingLines"
                        [contextMenu]="cm"
                        [(selection)]="this.selected"
                        contextMenuSelectionMode="joint"
                        [(contextMenuSelection)]="this.selected"
                        [scrollable]="true"
                        scrollHeight="500px"
                        class="reportDefinitionLinesTable"
                        styleClass="p-datatable-striped"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <th
                                    style="
                                        width: 10% !important;
                                        max-width: 15% !important;
                                    "
                                >
                                    Row #
                                </th>
                                <th
                                    style="
                                        width: 150px !important;
                                        max-width: 150px !important;
                                    "
                                >
                                    Type
                                </th>
                                <th style="min-width: 400px !important">
                                    Description
                                </th>
                                <th style="min-width: 200px !important">
                                    Parent Line
                                </th>
                                <th
                                style="
                                text-align: center;
                                width: 200px !important;
                                max-width: 300px !important;
                            ">
                                    Actions
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rowData>
                            <tr
                                [pSelectableRow]="rowData"
                                [pContextMenuRow]="rowData"
                                (dblclick)="viewReportDefinitionLine(rowData)"
                            >
                                <td
                                    style="
                                        width: 10% !important;
                                        max-width: 15% !important;
                                    "
                                >
                                    {{ rowData.RowNo }}
                                </td>
                                <td
                                    style="
                                        width: 150px !important;
                                        max-width: 150px !important;
                                    "
                                >
                                    {{ rowData.TotalingType.name.slice(4) }}
                                </td>
                                <td style="min-width: 400px !important">
                                    {{ rowData.Description }}
                                </td>
                                <td style="min-width: 400px !important">
                                    {{ rowData.ParentLine.name }}
                                </td>
                                <td
                                    style="
                                        text-align: center;
                                        width: 200px !important;
                                        max-width: 300px !important;
                                    "
                                >
                                    <button
                                        class="
                                            ui-button-information
                                            ui-button__center
                                        "
                                        type="button"
                                        pButton
                                        (click)="
                                            viewReportDefinitionLine(rowData)
                                        "
                                        pTooltip="Edit Report Line"
                                        tooltipPosition="top"
                                        icon="ui-icon-edit"
                                        [disabled]="isDisabled"
                                    ></button>
                                    <button
                                    class="
                                        ui-button-information
                                        ui-button__center
                                    "
                                    type="button"
                                    pButton
                                    (click)="
                                        copyReportLine(rowData)
                                    "
                                    pTooltip="Copy to Report..."
                                    tooltipPosition="top"
                                    icon="pi pi-copy"
                                    [disabled]="isDisabled"
                                ></button>
                                    <button
                                        *ngIf="rowData.TotalingType.id == 1"
                                        class="
                                            ui-button-information
                                            ui-button__center
                                        "
                                        type="button"
                                        pButton
                                        (click)="
                                            openSelectedLineAccounts(rowData)
                                        "
                                        pTooltip="Included Accounts"
                                        tooltipPosition="top"
                                        icon="ui-icon-remove-red-eye"
                                        [disabled]="isDisabled"
                                    ></button>
                                    <button
                                        *ngIf="rowData.TotalingType.id == 1"
                                        class="
                                            ui-button-information
                                            ui-button__center
                                        "
                                        type="button"
                                        pButton
                                        (click)="
                                            openExcludedLineAccounts(rowData)
                                        "
                                        pTooltip="Excluded Accounts"
                                        tooltipPosition="top"
                                        icon="ui-icon-remove-circle"
                                        [disabled]="isDisabled"
                                    ></button>
                                    <button
                                        class="
                                            ui-button-information
                                            ui-button__center
                                        "
                                        type="button"
                                        pButton
                                        (click)="
                                            deleteReportDefinitionLine(rowData)
                                        "
                                        pTooltip="Delete Report Line"
                                        tooltipPosition="top"
                                        icon="ui-icon-delete"
                                        [disabled]="isDisabled"
                                    ></button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>-->
                    <p-contextMenu
                        #cm
                        [model]="items"
                        appendTo="body"
                    ></p-contextMenu>
                </div>
            </div>
        </div>
    </div>
    <div class="ui-g-12">
        <button
            type="button"
            label="Save"
            pButton
            icon="ui-icon-save"
            (click)="saveClick($event)"
            [disabled]="isDisabled"
        ></button>
        <button
            *ngIf="this.id !== 'new'"
            type="button"
            label="Save & Close"
            pButton
            icon="ui-icon-save"
            (click)="saveCloseClick($event)"
            [disabled]="isDisabled"
        ></button>
        <button
            type="button"
            label="Cancel"
            pButton
            icon="ui-icon-cancel"
            (click)="cancelClick($event)"
            [disabled]="isDisabled"
        ></button>
    </div>
</div>

<p-dialog
    [modal]="true"
    [draggable]="false"
    [closable]="false"
    [(visible)]="reportDetailsEditMode"
    *ngIf="reportDetailsEditMode"
    [style]="{ width: '90%' }"
    class="ui-fluid clear-ui dont-show-dialog-titlebar dialog-top"
>
    <h4 style="margin-top: 0px">Edit Report Details</h4>
    <div class="ui-g form-group">
        <div class="ui-g-12">
            <div class="p-float-label">
                <p-dropdown
                    [disabled]="!canReportTypeBeChanged"
                    [options]="reportTypes"
                    [(ngModel)]="object.ReportType"
                    dataKey="id"
                    optionLabel="name"
                    [autoDisplayFirst]="false"
                    (onChange)="onTypeReportChange($event)"
                >
                </p-dropdown>
                <label>Report Type</label>
            </div>
        </div>
        <div class="ui-g-12" *ngIf="this.displayReportAnalysisArea">
            <div class="p-float-label">
                <p-dropdown
                    [disabled]="!canReportTypeBeChanged"
                    [options]="factTypes"
                    [(ngModel)]="object.FactType"
                    dataKey="id"
                    optionLabel="name"
                    [autoDisplayFirst]="false"
                >
                </p-dropdown>
                <label>Report Analysis Area</label>
            </div>
        </div>
        <div class="ui-g-12">
            <div class="p-float-label">
                <input
                    pInputText
                    [(ngModel)]="object.Name"
                    mask="AAAAAA"
                    [patterns]="nameMaskPattern"
                    [validation]="false"
                    [maxLength]="20"
                />
                <label>Code</label>
            </div>
        </div>
        <div class="ui-g-12">
            <div class="p-float-label">
                <input
                    pInputText
                    [(ngModel)]="object.Description"
                    [maxLength]="80"
                />
                <label>Name</label>
            </div>
        </div>
        <div class="ui-g-12">
            <div class="p-float-label">
                <input pInputText [(ngModel)]="object.ReportPreviewLink" />
                <label>Report Preview Link (with http:// or https://)</label>
            </div>
        </div>
        <div class="ui-g-12">
            <button
                type="button"
                label="Save"
                pButton
                icon="ui-icon-check"
                (click)="saveEditReport()"
                [disabled]="isDisabled"
            ></button>
            <button
                type="button"
                label="Cancel"
                pButton
                icon="ui-icon-cancel"
                (click)="cancelEditReport()"
                [disabled]="isDisabled"
            ></button>
        </div>
    </div>
</p-dialog>

<p-dialog
    (onShow)="onShow()" 
    [modal]="true"
    [draggable]="false"
    [closable]="false"
    [(visible)]="displayline"
    *ngIf="displayline"
    [style]="{ width: '90%', height: '90%' }"
    class="ui-fluid clear-ui dont-show-dialog-titlebar dialog-top"
>
    <h4 style="margin-top: 0px">Report definition line</h4>

    <div class="ui-g form-group">
        <div class="ui-g-6">
            <div class="p-float-label">
                <input
                    type="text"
                    pInputText
                    [(ngModel)]="objectline.RowNo"
                    [maxLength]="20"
                />
                <label>Row no.</label>
            </div>
        </div>
        <div class="ui-g-6">
            <div class="p-float-label">
                <input
                    type="text"
                    pInputText
                    [(ngModel)]="objectline.Description"
                />
                <label>Description</label>
            </div>
        </div>
        <div class="ui-g-6">
            <div class="p-float-label">
                <p-dropdown
                    [options]="totalingTypes"
                    optionLabel="name"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="objectline.TotalingType"
                    dataKey="id"
                ></p-dropdown>
                <label>Totaling type</label>
            </div>
        </div>
        <div
            class="ui-g-6"
            *ngIf="objectline.TotalingType && objectline.TotalingType.id === 1 && object.ReportType.id == 1"
        >
            <div class="p-float-label">
                <p-dropdown
                    [options]="rowTypes"
                    optionLabel="name"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="objectline.RowType"
                    dataKey="id"
                ></p-dropdown>
                <label>Row type</label>
            </div>
        </div>
        <div
            class="ui-g-6"
            *ngIf="objectline.TotalingType && objectline.TotalingType.id === 1"
        >
            <div class="p-float-label">
                <p-dropdown
                    [options]="accountTypes"
                    optionLabel="name"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="objectline.AccountType"
                    dataKey="id"
                ></p-dropdown>
                <label>Account type</label>
            </div>
        </div>
        <div
        class="ui-g-6">
        <div class="p-float-label">
            <p-dropdown
                [options]="reportLineFormats"
                optionLabel="name"
                [autoDisplayFirst]="false"
                [(ngModel)]="objectline.ReportLineFormat"
                dataKey="id"
            ></p-dropdown>
            <label>Report Line Format</label>
        </div>
    </div>
        <div
            class="ui-g-3"
        >
            <div class="p-float-label">
                <p-dropdown
                [options]="reportLines"
                optionLabel="name"
    [autoDisplayFirst]="false"
    [(ngModel)]="objectline.ParentLine"
    dataKey="id">
    
   <!--  <ng-template let-option pTemplate="item">
        {{ option.Id }} - {{ option.Name }}
    </ng-template>

    <ng-template let-selectedOption pTemplate="selectedItem">
        {{ selectedOption ? (selectedOption.Id + ' - ' + selectedOption.Name) : 'Select an option' }}
    </ng-template> -->
</p-dropdown>
            <label>Parent Line</label>
            </div>
        </div>
        <div
            class="ui-g-6"
        >
            <div class="ui-float-label">
                <p-checkbox
                    name="cg"
                    label="Show opposite sign"
                    binary="true"
                    [(ngModel)]="objectline.ShowOppositeSign"
                ></p-checkbox>
                <p-checkbox
                    name="cg"
                    label="Show values"
                    binary="true"
                    [(ngModel)]="objectline.ShowValues"
                ></p-checkbox>
            </div>
        </div>
        <div
            class="ui-g-6"
            *ngIf="objectline.TotalingType && objectline.TotalingType.id === 3"
        >
            <div class="p-float-label">
                <p-dropdown
                    [options]="formulaTypes"
                    optionLabel="name"
                    [autoDisplayFirst]="false"
                    [(ngModel)]="objectline.Formula"
                >
                </p-dropdown>
                <label>Formula type</label>
            </div>
        </div>
    </div>

    <div *ngIf="currOperation === 'new'" style="height: 150px"></div>

    <div *ngIf="currOperation === 'edit'">
        <div
            *ngIf="objectline.TotalingType && objectline.TotalingType.id === 4"
        >
            <h4>Constant</h4>
            <div class="ui-g form-group">
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <input
                            type="text"
                            pInputText
                            [(ngModel)]="objectline.Constant"
                            mask="0*.00"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div
            *ngIf="objectline.TotalingType && objectline.TotalingType.id === 1"
        >
            <h4>Accounts Totaling</h4>
            <dimension-totaling
                [isDisabled]="this.isDisabled"
                [(totaling)]="this.objectline.Totaling"
                [reportId]="this.id"
                [lineId]="this.objectline.Id"
                (totalingChange)="updateLineTotaling()"
            ></dimension-totaling>
        </div>

        <div
            *ngIf="objectline.TotalingType && objectline.TotalingType.id === 3"
        >
            <h4>Formula</h4>

            <p *ngIf="!objectline.Formula">Please pick formula type</p>

            <app-formula-picker
                *ngIf="objectline.Formula && objectline.Formula.id"
                name="Pick Formula A"
                label="A"
                [reportId]="this.id"
                [(report)]="this.objectline.ARep"
                [(formulaElement)]="this.objectline.A"
                [lineId]="this.objectline.Id"
            ></app-formula-picker>
            <app-formula-picker
                *ngIf="objectline.Formula && objectline.Formula.id !== 6"
                name="Pick Formula B"
                label="B"
                [reportId]="this.id"
                [(report)]="this.objectline.BRep"
                [(formulaElement)]="this.objectline.B"
                [lineId]="this.objectline.Id"
            ></app-formula-picker>
            <app-formula-picker
                *ngIf="
                    objectline.Formula &&
                    (objectline.Formula.id === 1 ||
                        objectline.Formula.id === 4 ||
                        objectline.Formula.id === 5 ||
                        objectline.Formula.id === 8 ||
                        objectline.Formula.id === 9)
                "
                name="Pick Formula C"
                label="C"
                [reportId]="this.id"
                [(report)]="this.objectline.CRep"
                [(formulaElement)]="this.objectline.C"
                [lineId]="this.objectline.Id"
            ></app-formula-picker>
            <app-formula-picker
                *ngIf="
                    objectline.Formula &&
                    (objectline.Formula.id === 1 || objectline.Formula.id === 9)
                "
                name="Pick Formula D"
                label="D"
                [reportId]="this.id"
                [(report)]="this.objectline.DRep"
                [(formulaElement)]="this.objectline.D"
                [lineId]="this.objectline.Id"
            ></app-formula-picker>
        </div>

        <div
            class="ui-g-12"
            *ngIf="
                (this.object.Dimension1 ||
                this.object.Dimension2 ||
                this.object.Dimension3 ||
                this.object.Dimension4) && objectline.TotalingType.id !== 4
            "
        >
            <h4>Dimensions totaling 1-4</h4>

            <p-tabView>
                <p-tabPanel [header]="object.Dimension1">
                    <dimension-totaling
                        mode="dimensions"
                        [reportId]="this.id"
                        [lineId]="this.objectline.Id"
                        [isDisabled]="this.isDisabled"
                        [(totaling)]="this.objectline.DimensionsTotaling1"
                        [dimensionId]="this.object.DimensionId1"
                        (totalingChange)="updateLineTotalingRange()"
                    ></dimension-totaling>
                </p-tabPanel>
                <p-tabPanel [header]="object.Dimension2">
                    <dimension-totaling
                        mode="dimensions"
                        [isDisabled]="this.isDisabled"
                        [reportId]="this.id"
                        [lineId]="this.objectline.Id"
                        [(totaling)]="this.objectline.DimensionsTotaling2"
                        [dimensionId]="this.object.DimensionId2"
                        (totalingChange)="updateLineTotalingRange()"
                    ></dimension-totaling>
                </p-tabPanel>
                <p-tabPanel [header]="object.Dimension3">
                    <dimension-totaling
                        mode="dimensions"
                        [isDisabled]="this.isDisabled"
                        [reportId]="this.id"
                        [lineId]="this.objectline.Id"
                        [(totaling)]="this.objectline.DimensionsTotaling3"
                        [dimensionId]="this.object.DimensionId3"
                        (totalingChange)="updateLineTotalingRange()"
                    ></dimension-totaling>
                </p-tabPanel>
                <p-tabPanel [header]="object.Dimension4">
                    <dimension-totaling
                        mode="dimensions"
                        [isDisabled]="this.isDisabled"
                        [reportId]="this.id"
                        [lineId]="this.objectline.Id"
                        [(totaling)]="this.objectline.DimensionsTotaling4"
                        [dimensionId]="this.object.DimensionId4"
                        (totalingChange)="updateLineTotalingRange()"
                    ></dimension-totaling>
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>

    <div class="ui-g-12">
        <button
            type="button"
            label="Save"
            pButton
            icon="ui-icon-check"
            (click)="saveClickLine()"
            [disabled]="isDisabled"
        ></button>
        <button
            type="button"
            label="Save & Close"
            pButton
            icon="ui-icon-check"
            (click)="saveClickLine(true)"
            [disabled]="isDisabled"
        ></button>
        <button
            type="button"
            label="Cancel"
            pButton
            icon="ui-icon-cancel"
            (click)="cancelLineChanges()"
            [disabled]="isDisabled"
        ></button>
    </div>
</p-dialog>

<modal-show-line-accounts
    [lineId]="this.selected.Id"
    filter="excluded"
    *ngIf="displayExcludedLineAccounts"
    (onClose)="displayExcludedLineAccounts = false"
>
</modal-show-line-accounts>

<modal-show-line-accounts
    [lineId]="this.selected.Id"
    filter="included"
    *ngIf="displayIncludedLineAccounts"
    (onClose)="displayIncludedLineAccounts = false"
>
</modal-show-line-accounts>

<p-dialog class="ui-fluid" header="Copy to report..." [(visible)]="displayCopyReportLine" *ngIf="displayCopyReportLine"
[style]="{width: '40%', height:'40%'}" appendTo="body">
<br>
<div  class="ui-g form-group">
    <div class="ui-g-12">
        <div class="p-float-label">
            <p-dropdown class="dropdown-reportDefinitions" [(ngModel)]="company" [options]="companiesAll" optionLabel="name" [autoDisplayFirst]=false
                dataKey="id" (onChange)="companyChanged($event)"></p-dropdown>
        <label>Company</label>
        </div>
    </div>
</div>
<div  class="ui-g form-group">
    <div class="ui-g-12">
        <div class="p-float-label">
            <p-dropdown class="dropdown-reportDefinitions" (onChange)="dataChanged($event)" [options]="this.reports" optionLabel="Name" [autoDisplayFirst]=false
        dataKey="Id" ></p-dropdown>
        <label>Report code</label>
        </div>
    </div>
</div>
<div  class="ui-g-12">
    <button label="Copy" pButton icon="pi pi-check" (click)="copyToReportClick()" [disabled]="isDisabled" 
        style="margin-right: 0.5em"></button>
    <button label="Cancel" pButton icon="pi pi-times" [disabled]="isDisabled" 
        (click)="displayCopyReportLine=false;"></button>
</div>

</p-dialog>
